<ng-container *ngIf="engineJobs$ | async as engineJobs">

  <p-breadcrumb
    class="max-w-full"
    [model]="engineJobs.breadcrumbs"
    [style]="{ border: 'none', padding: '1rem 0', background: 'var(--surface-card)' }"
    ></p-breadcrumb>
  <div class="p-mb-4">
    <div class="p-d-flex p-jc-between p-ai-center p-mb-2">
      <h2 class="p-m-0">{{ engineJobs.title }}</h2>
      <div class="p-py-2">
        <p-dropdown
          [ngModel]="engineJobs.sortBy"
          (ngModelChange)="setSortBy($event)"
          appendTo="body"
          [options]="sortByOptions"
          ></p-dropdown>
      </div>
    </div>
    <section class="metrics">
      <app-overview-chip
        *ngFor="let chip of engineJobs.chips"
        [value]="chip.chipType === 'currency' ? (chip.value | currency : engineJobs.currency) : chip.chipType === 'percent' ? (chip.value | number : '1.0-2') + '%' : chip.value"
        [label]="chip.label"
        [icon]="chip.chipType === 'currency' ? 'pi-dollar' : chip.chipType === 'percent' ? 'pi-arrow-right' : 'pi-th-large'"
        ></app-overview-chip>
    </section>
  </div>

  <div>

    <div *ngIf="!engineJobs.isEmpty">

      <div *ngFor="let section of engineJobs.sections" class="p-mb-4">
        <h3 class="p-mb-1" *ngIf="section.title">{{ section.title }}</h3>
        <div class="jobs">
          <ng-container *ngIf="!engineJobs.loading">
            <app-engine-job *ngFor="let job of section.jobs" [job]="job"></app-engine-job>
          </ng-container>
          <ng-container *ngIf="engineJobs.fetchingMore">
            <p-skeleton
              *ngFor="let skeleton of fetchingMoreSkeletons"
              height="5rem"
              [style]="{ borderRadius: '12px' }"
            ></p-skeleton>
          </ng-container>

          <ng-container *ngIf="engineJobs.loading">
            <p-skeleton
              *ngFor="let skeleton of section.loadingSkeletons"
              height="5rem"
              [style]="{ borderRadius: '12px' }"
            ></p-skeleton>
          </ng-container>
        </div>
        <div class="p-d-flex p-jc-between p-ai-center p-py-2">
          <div>
            <p-button
            *ngIf="section.button"
            styleClass="view-button"
            [label]="section.button.label"
            (onClick)="section.button.command()"
            icon="pi pi-arrow-right"
            iconPos="right"
            ></p-button>
          </div>
          <a
          [routerLink]="['/reports', 'dynamic', 'new']"
          [queryParams]="section.reportParams"
          target="_blank"
          class="p-button p-button-outlined view-report"
          ><i class="pi pi-chart-line p-mr-2"></i>View Report</a>
        </div>
      </div>

    </div>

    <app-dashboard-empty-state *ngIf="engineJobs.isEmpty" text="No jobs to show. Select jobs from the chart or change your filters."></app-dashboard-empty-state>

  </div>

</ng-container>
